var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOfficeBuilding = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4 4.85A2.85 2.85 0 0 1 6.85 2h10a2.85 2.85 0 0 1 2.85 2.85V20h1.15a.85.85 0 1 1 0 1.7h-18a.85.85 0 0 1 0-1.7H4zM5.7 20H9v-4.15A1.85 1.85 0 0 1 10.85 14h2a1.85 1.85 0 0 1 1.85 1.85V20H18V4.85a1.15 1.15 0 0 0-1.15-1.15h-10A1.15 1.15 0 0 0 5.7 4.85zm7.3 0v-4.15a.15.15 0 0 0-.15-.15h-2a.15.15 0 0 0-.15.15V20zM8 6.85c0-.47.38-.85.85-.85h1a.85.85 0 0 1 0 1.7h-1A.85.85 0 0 1 8 6.85m5 0c0-.47.38-.85.85-.85h1a.85.85 0 0 1 0 1.7h-1a.85.85 0 0 1-.85-.85m-5 4c0-.47.38-.85.85-.85h1a.85.85 0 1 1 0 1.7h-1a.85.85 0 0 1-.85-.85m5 0c0-.47.38-.85.85-.85h1a.85.85 0 1 1 0 1.7h-1a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgOfficeBuilding;